import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import MaleUsersPage from "../views/MaleUsersPage.vue";
import FemaleUsersPage from "../views/FemaleUsersPage.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/male-users",
    name: "MaleUsersPage",
    component: MaleUsersPage
  },
  {
    path: "/female-users",
    name: "FemaleUsersPage",
    component: FemaleUsersPage
  }
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
